import { useEditor } from '@modules/editor';
import EmptyContent from 'src/components/empty-content';
import Scrollbar from 'src/components/scrollbar';
import { SkeletonConversationItem } from 'src/components/skeleton';
import { useChatConversationContext } from 'src/sections/@dashboard/chat/ChatConversation/useChatConversationContext';
import { ChatThreadItem } from 'src/sections/@dashboard/chat/ChatHeader/ChannelThreads/ChatThreadItem';
import { useChatThreads } from 'src/sections/@dashboard/chat/ChatHeader/ChannelThreads/useChannelThreads';

const ITEM_HEIGHT = 162;

export const ChatThreadsList = ({
  channelId,
  handleClose,
}: { channelId: string; handleClose: () => void }) => {
  const { editorConfig } = useChatConversationContext();

  const { editor, editorLoaded } = useEditor(editorConfig);

  const { isFetching, conversation } = useChatThreads({ channelId });
  if (isFetching) {
    return (
      <>
        <SkeletonConversationItem />
        <SkeletonConversationItem />
      </>
    );
  }

  if (!conversation?.subchannels?.length) {
    return (
      <EmptyContent
        sx={{ height: 300 }}
        title="No Threads"
        description="This conversation has no threads."
        img="/assets/illustrations/illustration_empty_content.svg"
      />
    );
  }

  if (!editorLoaded) {
    return null;
  }

  return (
    <Scrollbar sx={{ maxHeight: ITEM_HEIGHT * 2, height: 'auto' }}>
      {conversation.subchannels.map((thread) => (
        <ChatThreadItem
          key={thread._id}
          thread={thread}
          editor={editor}
          channelId={channelId}
          handleClose={handleClose}
        />
      ))}
    </Scrollbar>
  );
};
